import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { PatientExternalAgencyUsers } from 'src/app/core/models/patient-external-agency-user';
import { formatIndividualName } from 'src/app/core/utils/autocomplete-util';

const getExternalAgencyUserUrl = '/patients/getExternalAgencyUserDetail.html';

@Injectable({
  providedIn: 'root'
})
export class ExternalAgencyUserService {
  constructor(private http: HttpClient) {}

  getExternalAgencyUser(extAgencyUserId: string): Observable<PatientExternalAgencyUsers> {
    return this.http.post<PatientExternalAgencyUsers>(getExternalAgencyUserUrl, '', {
      params: {
        extAgencyUserId: extAgencyUserId
      }
    });
  }

  getExternalAgencyUserName(extAgencyUserId: string): Observable<string> {
    return this.getExternalAgencyUser(extAgencyUserId).pipe(
      map((externalAgencyUser) => {
        return formatIndividualName(externalAgencyUser);
      })
    );
  }
}
